import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../app.json";
import ActivePage from "../../../partials/active-page";
import NewNoteCategory from "./NewNoteCategory";
import ListNoteCategory from "./ListNoteCategory";
import UpdateNoteCategory from "./UpdateNoteForm";
import {
	NEW_CARE_NOTE_ITEM,
	GET_CARE_NOTE_LIST,
	UPDATE_NOTE_ITEM,
	REMOVE
} from "../../../queries/noteCategory.query";
import { useQuery, useMutation } from "@apollo/react-hooks";
import auth from "../../../providers/Auth.Provider";
import LoadingSpinner from "../../../partials/loading";
import AlertMessage from "../../../partials/alertMessage";
import { Redirect } from "react-router-dom";

const CareNoteCategory = ({ match, location }) => {
	// local state
	const [newNote, setNewNote] = useState(false);
	const [noteCategory, setNoteCategory] = useState(null);

	const { GetToken, GetAuthenticatedStaff } = auth.authProvider;
	const { site } = GetToken() && GetAuthenticatedStaff();

	// query
	const { loading, data, error } = useQuery(GET_CARE_NOTE_LIST, {
		variables: { site: site && site.id }
	});
	// Mutation
	const [
		CreateCategory,
		{ loading: cLoading, error: cError, data: cData }
	] = useMutation(NEW_CARE_NOTE_ITEM, {
		update(caches, { data: { NewCareNoteCategory } }) {
			const { GetCareNoteCategories } = caches.readQuery({
				query: GET_CARE_NOTE_LIST,
				variables: { site: site && site.id }
			});

			GetCareNoteCategories.docs.unshift(NewCareNoteCategory.doc);
			caches.writeQuery({
				query: GET_CARE_NOTE_LIST,
				variables: { site: site && site.id },
				data: { GetCareNoteCategories }
			});
		}
	});
	//  Update Mutation
	const [
		UpdateNoteCategoryFunc,
		{ loading: uLoading, error: uError }
	] = useMutation(UPDATE_NOTE_ITEM);

	// props
	const title = "Care Note Category";
	const pages = [
		{
			title: "Application Management",
			path: "/home/app-management"
		},
		{ title, path: match.path }
	];
	const [
		removeFunc,
		{ loading: removeLoading, error: removeError }
	] = useMutation(REMOVE, {
		update(caches, { data: { DeleteNoteCategory } }) {
			const { GetCareNoteCategories } = caches.readQuery({
				query: GET_CARE_NOTE_LIST,
				variables: { site: site && site.id }
			});

			GetCareNoteCategories.docs.splice(
				GetCareNoteCategories.docs.findIndex(
					x => x.id === DeleteNoteCategory.doc.id
				),
				1
			);
			caches.writeQuery({
				query: GET_CARE_NOTE_LIST,
				variables: { site: site && site.id },
				data: { GetCareNoteCategories }
			});
		}
	});
	if (error && auth.authProvider.IsAuthenticationError(error.message)) {
		auth.authProvider.LogOut();
		return (
			<Redirect
				to={{
					pathname: "/login",
					search: `?redirect=${location.pathname}`
				}}
			/>
		);
	}
	return (
		<>
			<Helmet>
				<title>
					{title} | {appName}
				</title>
			</Helmet>
			<ActivePage pages={pages} title={title} />
			<div className="row justify-content-center">
				{newNote && !noteCategory && (
					<div className="col-md-10 fade-in">
						<div className="card">
							<div className="card-head">
								<header>
									<button
										onClick={() => {
											setNoteCategory(null);
											setNewNote(false);
										}}
										className="mdl-button mdl-js-button mdl-button--icon margin-right-5"
									>
										<i className="material-icons">
											arrow_back_ios
										</i>
									</button>
									New Care note category
								</header>
							</div>
							<div className="card-body">
								<LoadingSpinner loading={cLoading} />
								<AlertMessage
									message={
										cData &&
										cData.NewCareNoteCategory.message
									}
								/>
								<AlertMessage
									message={cError && cError.message}
									failed={true}
								/>
								<NewNoteCategory
									onCancel={() => {
										setNoteCategory(null);
										setNewNote(false);
									}}
									onSubmit={async item => {
										await CreateCategory({
											variables: {
												model: {
													site: site && site.id,
													...item
												}
											}
										});
										setNoteCategory(null);
										setNewNote(false);
									}}
								/>
							</div>
						</div>
					</div>
				)}

				{!newNote && noteCategory && (
					<div className="col-md-10 fade-in">
						<div className="card">
							<div className="card-head">
								<header>
									<button
										onClick={() => {
											setNoteCategory(null);
											setNewNote(false);
										}}
										className="mdl-button mdl-js-button mdl-button--icon margin-right-5"
									>
										<i className="material-icons">
											arrow_back_ios
										</i>
									</button>
									Update Care Note Category
								</header>
							</div>
							<div className="card-body">
								<LoadingSpinner loading={uLoading} />
								<AlertMessage
									message={uError && uError.message}
									failed={true}
								/>
								<UpdateNoteCategory
									onCancel={() => {
										setNoteCategory(null);
										setNewNote(false);
									}}
									currentValue={noteCategory}
									onSubmit={async ({ name, icon }) => {
										await UpdateNoteCategoryFunc({
											variables: {
												name,
												icon,
												id: noteCategory.id
											}
										});
										setNoteCategory(null);
										setNewNote(false);
									}}
								/>
							</div>
						</div>
					</div>
				)}
				{!newNote && !noteCategory && (
					<div className="col-md-10 fade-in">
						<div className="card">
							<div className="card-head">
								<header>Care Note Category</header>
								<div className="tools">
									<button
										title="Add Care Note Category"
										onClick={() => {
											setNewNote(!newNote);
											setNoteCategory(null);
										}}
										className="mdl-button mdl-button--icon margin-right-10 btn-success"
									>
										<i className="material-icons">add</i>
									</button>
								</div>
							</div>
							<div className="card-body m-b-20">
								<LoadingSpinner
									loading={loading || removeLoading}
								/>
								<AlertMessage
									message={
										(error && error.message) ||
										(removeError && removeError.message)
									}
									failed={true}
								/>
								{!loading && (
									<ListNoteCategory
										items={
											data &&
											data.GetCareNoteCategories.docs
										}
										onEdit={item => {
											setNoteCategory(item);
											setNewNote(false);
											document.body.scrollTop = 0;
											document.documentElement.scrollTop = 0;
										}}
										onRemove={async item => {
											if (
												window.confirm(
													"Are you sure you want to delete this record!"
												)
											) {
												await removeFunc({
													variables: { id: item.id }
												});
											}
										}}
									/>
								)}
							</div>
						</div>
					</div>
				)}
			</div>
		</>
	);
};

export default CareNoteCategory;
